module.exports = __webpack_public_path__ + "media/Sequence_01_7.b0bcf965.mp4";